import { Check } from "lucide-react";
import { IMAGES, ABOUT_POINTS } from "../../data/content";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const About = () => (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32">
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-10">
            <Reveal className="relative order-2 lg:order-1">
                <div aria-hidden="true" className="absolute -left-4 -top-4 h-full w-full rounded-[2rem] bg-mist" />
                <div className="relative overflow-hidden rounded-[2rem] shadow-[0_30px_60px_-20px_rgba(11,31,42,0.25)]">
                    <img
                        src={IMAGES.about}
                        alt="Modern, calm dental clinic treatment room"
                        loading="lazy"
                        className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
                    />
                </div>
                <div className="absolute -bottom-6 -right-3 rounded-2xl bg-ink px-6 py-5 text-[#f8f6f0] shadow-xl sm:-right-6">
                    <p className="font-display text-2xl italic text-teal-300">Kasba</p>
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-300">Kolkata, West Bengal</p>
                </div>
            </Reveal>

            <div className="order-1 lg:order-2">
                <SectionHeading
                    number="01"
                    eyebrow="About the Clinic"
                    title="Personalized Dental Care for"
                    accent="Every Smile"
                />
                <Reveal delay={0.15}>
                    <p className="mt-6 text-base leading-relaxed text-slate-600 md:text-lg">
                        At {`Smile Dental Clinic`}, every visit begins with listening. The clinic focuses on thoughtful
                        dental consultation, preventive care and personalized treatment — so you understand your oral
                        health clearly and feel confident about every step of your care.
                    </p>
                </Reveal>
                <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {ABOUT_POINTS.map((point, i) => (
                        <Reveal key={point} delay={0.1 + i * 0.06}>
                            <li data-testid={`about-point-${i}`} className="flex items-center gap-3 rounded-xl border border-ink/10 bg-white px-4 py-3">
                                <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-teal-accent/10 text-teal-accent">
                                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                                </span>
                                <span className="text-sm font-bold text-ink/85">{point}</span>
                            </li>
                        </Reveal>
                    ))}
                </ul>
            </div>
        </div>
    </section>
);
